import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { PushPipe } from '@ngrx/component';
import { WdxFormFieldModule } from '@wdx/shared/components/wdx-form-field';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxRadioModule } from '@wdx/shared/components/wdx-radio';
import {
    WdxRadioTileGroupModule,
    WdxRadioTileModule,
} from '@wdx/shared/components/wdx-radio-tile';
import {
    FileTypeAsIconPipe,
    TranslateTokenisedStringPipe,
} from '@wdx/shared/utils';
import { AtomAsyncButtonModule } from '../../../../components/atoms/atom-async-button/atom-async-button.module';
import { AtomAsyncDataModule } from '../../../../components/atoms/atom-async-data/atom-async-data.module';
import { AtomFeatureSvgModule } from '../../../../components/atoms/atom-feature-svg/atom-feature-svg.module';
import { OrganismModalModule } from '../../../../components/organisms/organism-modal/organism-modal.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { GenerateDocumentTemplateFormComponent } from './generate-document-template-form/generate-document-template-form.component';
import { GenerateDocumentTemplateModalComponent } from './generate-document-template-modal.component';

@NgModule({
    declarations: [
        GenerateDocumentTemplateModalComponent,
        GenerateDocumentTemplateFormComponent,
    ],
    imports: [
        AtomAsyncButtonModule,
        AtomAsyncDataModule,
        AtomFeatureSvgModule,
        CommonModule,
        NgbAccordionModule,
        NgSelectModule,
        OrganismModalModule,
        PipesModule,
        PushPipe,
        ReactiveFormsModule,
        WdxFormFieldModule,
        WdxRadioModule,
        WdxRadioTileGroupModule,
        WdxRadioTileModule,
        WdxIconModule,
        FileTypeAsIconPipe,
        TranslateTokenisedStringPipe,
    ],
    exports: [GenerateDocumentTemplateModalComponent],
})
export class GenerateDocumentTemplateModalModule {}
